// Uma runtime nunca adota a geração posterior a um reset. A reabertura cria outro módulo.
const generations = new Map<string, number>();
let current: { epoch: number; read: () => Promise<number> } | undefined;
export function bindLocalDatabaseEpoch(name: string, epoch: number, read: () => Promise<number>) {
  const previous = generations.get(name);
  if (previous !== undefined && previous !== epoch) throw Error('database_reset_restart_required');
  generations.set(name, epoch);
  current = { epoch, read };
}
export const boundLocalDatabaseEpoch = () => current?.epoch;
export async function isLocalDatabaseEpochCurrent(expected: number | undefined): Promise<boolean> {
  if (expected === undefined) return current === undefined;
  if (!current || current.epoch !== expected) return false;
  try { return await current.read() === expected; } catch { return false; }
}
